import { get, isEmpty } from 'lodash';
import type { FormInstance } from 'antd';

export function flattenKeys(obj: Record<string, any>, path: string[] = []) {
  let keys: string[][] = [];
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      keys = keys.concat(flattenKeys(obj[key], path.concat(key)));
    } else {
      keys.push(path.concat(key));
    }
  }
  return keys;
}

export const formValidator = async (
  form: FormInstance,
  formConfigs: { key: string[]; dependencies?: (v) => boolean }[],
  enableRequiredInFormItem: boolean = true,
) => {
  if (enableRequiredInFormItem) {
    // default antd form validation
    try {
      const values = await form?.validateFields();
      return values;
    } catch (e: any) {
      return Promise.reject({ errorFields: e.errorFields });
    }
  }

  let errorFields: Record<string, string> = {};
  try {
    const values = await form?.validateFields();
    formConfigs.forEach((config) => {
      if (!config.dependencies || config.dependencies?.(values)) {
        const value = get(values, config.key);
        if (value === undefined || value === null || value === '') {
          errorFields[config.key.join('.')] = 'Required';
        }
      }
    });
    if (isEmpty(errorFields)) {
      return values;
    } else {
      return Promise.reject({ errorFields, checked: true });
    }
  } catch (e: any) {
    if (!e.checked) {
      errorFields = e.errorFields.reduce((acc, cur) => {
        acc[cur.name.join('.')] = cur.errors[0];
        return acc;
      }, {});

      formConfigs.forEach((config) => {
        if (!config.dependencies || config.dependencies?.(e.values)) {
          const value = get(e.values, config.key);
          if (
            !errorFields[config.key.join('.')] &&
            (value === undefined || value === null || value === '')
          ) {
            errorFields[config.key.join('.')] = 'Required';
          }
        }
      });
    }
    return Promise.reject({ errorFields });
  }
};

export const removeNullFromErrorEvent = (data) => {
  const hasErrorEvent = Object.prototype.hasOwnProperty.call(
    data?.definition?.events || {},
    'error_event',
  );
  // id == null can check for both null and undefined
  const filteredErrorEvent = (data?.definition?.events?.error_event || []).filter(
    (id) => id != null,
  );

  return {
    ...data,
    definition: {
      ...data?.definition,
      events: {
        ...data?.definition?.events,
        ...(hasErrorEvent ? { error_event: filteredErrorEvent } : {}), // Reserved only if 'error_event' exists
      },
    },
  };
};

export const arrayGroupBy = (array: any[], key: string) => {
  return array.reduce((result, item) => {
    const groupKey = item[key];
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    result[groupKey].push(item);
    return result;
  }, {});
};
